import { Fragment, createElement } from 'react'
import { formatDisplayTitle } from 'src/_helpers/formatDisplayTitle'
import { parseTitle, titleToText } from 'src/_helpers/titleMarkup'

const renderNodes = (nodes) =>
  nodes.map((node, index) =>
    node.tag ? (
      createElement(node.tag, { key: index }, renderNodes(node.children))
    ) : (
      <Fragment key={index}>{node.text}</Fragment>
    ),
  )

// Tytuł publikacji z kursywą oraz indeksem górnym i dolnym (API: App\Lib\TitleMarkup).
// HTML-a nie wstrzykujemy — renderujemy tylko te trzy znaczniki. Tytuł bez
// formatowania przechodzi przez formatDisplayTitle (import zapisany wersalikami).
const FormattedTitle = ({ value, fallback = null }) => {
  const nodes = parseTitle(value)

  if (!nodes.some((node) => node.tag)) {
    return formatDisplayTitle(titleToText(value)) || fallback
  }

  return <>{renderNodes(nodes)}</>
}

export default FormattedTitle
